import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import _ from 'lodash';

import { FormControl, InputLabel, MenuItem, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';

const CallClient = ({ instanceId }) => {
  const [client, setClient] = useState({
    name: '',
    icon: '',
    contacts: [],
  });

  const [crisisItems, setCrisisItems] = useState([]);
  const [subCrisisItems, setSubCrisisItems] = useState([]);
  const [crisisId, setCrisisId] = useState(null);
  const [subCrisisId, setSubCrisisId] = useState(null);
  const [recipients, setRecipients] = useState([]);

  const { id: clientId } = useParams();
  const history = useHistory();

  const onChangeCrisis = useCallback(
    (crisisId) => {
      setCrisisId(crisisId);
      const subItems = crisisItems.find((x) => x.id === crisisId).subItems;
      setSubCrisisItems(subItems);
    },
    [crisisItems, setCrisisId, setSubCrisisItems],
  );

  useEffect(() => {
    if (clientId && instanceId) {
      axios
        .get(`/api/clients/${clientId}`, { params: { instanceId } })
        .then(
          ({
            data: {
              client: { icon, ...client },
            },
          }) => {
            setClient({ ...client, icon: icon ? icon.toString() : '' });
          },
        )
        .catch((error) => {
          history.push('/clients');
        });
    }
  }, [clientId, instanceId]);

  useEffect(() => {
    axios.get('/api/crisisitems', { params: { instanceId } }).then((result) => {
      setCrisisItems(result.data.crisisItems);
      //   setCrisisId(result.data.crisisItems[0].id);
    });
  }, [instanceId]);

  useEffect(() => {
    if (crisisItems.length > 0) onChangeCrisis(crisisItems[0].id);
  }, [crisisItems, onChangeCrisis]);

  useEffect(() => {
    if (crisisId || subCrisisId)
      axios.get('/api/calls/recipients', { params: { clientId, crisisId: subCrisisId ? null : crisisId, subCrisisId } }).then((result) => {
        setRecipients(result.data.recipients);
      });
    else {
      setRecipients([]);
    }
  }, [clientId, crisisId, subCrisisId]);

  const onCallClient = () => {
    axios.post('/api/calls', { clientId, crisisId: subCrisisId ? null : crisisId, subCrisisId }).then((result) => {});
  };

  return (
    <form noValidate autoComplete="off">
      <Typography variant="h5" component="h3" gutterBottom>
        {`Call - ${client.name}`}
      </Typography>
      <Paper elevation={0}>
        <FormControl variant="standard">
          <InputLabel id="selected-crisis">Crisis</InputLabel>
          <Select labelId="selected-crisis" value={crisisId} onChange={(e) => onChangeCrisis(e.target.value)}>
            {crisisItems.map((x) => (
              <MenuItem key={x.id} value={x.id}>
                {x.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl variant="standard">
          <InputLabel id="selected-subcrisis">Sub-Crisis</InputLabel>
          <Select labelId="selected-subcrisis" value={subCrisisId} onChange={(e) => setSubCrisisId(e.target.value)}>
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {subCrisisItems.map((x) => (
              <MenuItem key={x.id} value={x.id}>
                {x.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Typography variant="subtitle1" component="h4" gutterBottom>
          Contacts
        </Typography>

        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Type</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {recipients.map((row) => (
              <TableRow key={row.email} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell>{row.type}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.phone}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
      <Button variant="contained" color="primary" onClick={onCallClient}>
        Call
      </Button>
    </form>
  );
};

export default CallClient;
